// import { REMOTE_DEFINITIONS } from '@gale.apps/constants/app.constant';
import { setRemoteDefinitions } from '@nx/angular/mf';

function processManifestDefinitions(definitions: any) {
  const baseUrl = window.location.host.includes('localhost') ? 'http://localhost' : window.location.protocol + "//" + window.location.host;

  for (const mfeName in definitions) {
    const [mfeValue, port] = definitions[mfeName].split(':');

    if (window.location.host.includes('localhost')) {
      definitions[mfeName] = `${baseUrl}:${port}`;
    } else {
      definitions[mfeName] = `${baseUrl}/${mfeValue}`;
    }
  }

  return definitions;
}

fetch('/assets/module-federation.manifest.json')
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(processManifestDefinitions(definitions)))
  // .then(() => setRemoteDefinitions(REMOTE_DEFINITIONS))
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
